
<div class="align-center">
  @if (label) {
    <div
      [innerHTML]="label | translate"
    class="mr-3"></div>
  }
  <div class="switch lh-1-point-5"
    (click)="onCheckboxClick()"
    [ngClass]="'switch-' + switchClass">
    <input type="checkbox"
      class="switch"
      [disabled]="isDisabled"
      [checked]="isChecked"
      [required]="isRequired"
      [id]="id">
      <label></label>
      <span class="pl-3" [hidden]="!isChecked" [innerHTML]="trueLabel | translate"></span>
      <span class="pl-3" [hidden]="isChecked" [innerHTML]="falseLabel | translate"></span>
    </div>
    @if (isDisabled) {
      <sb-icon
        class="ml-2 mr-1"
        name="locked"
        [ngbTooltip]="disabledMessage | translate">
      </sb-icon>
    }
    @if (description) {
      <sb-icon
        class="ml-2"
        name="info"
      [ngbTooltip]="description | translate"></sb-icon>
    }
  </div>